(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('prime-hero-slider')) {
  customElements.define('prime-hero-slider', class extends HTMLElement {
    connectedCallback() {
      this.slides = [...this.querySelectorAll('[data-hero-slide]')];
      this.dots = [...this.querySelectorAll('[data-hero-dot]')];
      this.controls = this.querySelector('[data-hero-controls]');
      this.play = this.querySelector('[data-hero-play]');
      this.status = this.querySelector('[data-hero-status]');
      this.index = 0;
      this.dataset.activeSlide = '1';
      if (this.slides.length < 2) return;
      this.abort = new AbortController();
      const signal = this.abort.signal;
      const on = (target, type, handler) => target.addEventListener(type, handler, { signal });
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.autoplay = this.dataset.autoplay === 'true';
      this.paused = !this.autoplay || this.motion.matches || !!window.Shopify?.designMode;
      this.hovered = false;
      this.editing = false;
      this.controls.hidden = false;
      on(this.querySelector('[data-hero-prev]'), 'click', () => this.show(this.index - 1));
      on(this.querySelector('[data-hero-next]'), 'click', () => this.show(this.index + 1));
      this.dots.forEach((dot, index) => on(dot, 'click', () => this.show(index)));
      on(this, 'keydown', event => {
        if (event.altKey || event.ctrlKey || event.metaKey || event.target.closest('input,textarea,select,[contenteditable="true"]')) return;
        const rtl = getComputedStyle(this).direction === 'rtl';
        let next;
        if (event.key === 'ArrowRight') next = this.index + (rtl ? -1 : 1);
        else if (event.key === 'ArrowLeft') next = this.index + (rtl ? 1 : -1);
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = this.slides.length - 1;
        else return;
        event.preventDefault();
        const fromDot = event.target.hasAttribute('data-hero-dot');
        this.show(next);
        if (fromDot) this.dots[this.index].focus();
      });
      on(this, 'pointerenter', event => { if (event.pointerType !== 'touch') { this.hovered = true; this.schedule(); } });
      on(this, 'pointerleave', event => { if (event.pointerType !== 'touch') { this.hovered = false; this.schedule(); } });
      on(this, 'focusin', event => {
        if (event.target === this.play && this.playIntent !== undefined) return;
        this.paused = true;
        this.schedule();
      });
      if (this.play) {
        on(this.play, 'pointerdown', () => { this.playIntent = this.paused; });
        on(this.play, 'pointercancel', () => { this.playIntent = undefined; });
        on(this.play, 'click', () => {
          this.paused = !(this.playIntent ?? this.paused);
          this.playIntent = undefined;
          this.schedule();
        });
      }
      on(this, 'pointerdown', event => {
        if (event.button !== 0 || !event.isPrimary || event.target.closest('a,button,input,textarea,select')) return;
        if (event.pointerType === 'mouse' && !event.target.closest('.prime-home-hero__media')) return;
        this.gesture = { id: event.pointerId, x: event.clientX, y: event.clientY };
        event.target.setPointerCapture?.(event.pointerId);
      });
      on(this, 'pointerup', event => {
        const start = this.gesture;
        this.gesture = null;
        if (!start || start.id !== event.pointerId) return;
        const dx = event.clientX - start.x, dy = event.clientY - start.y;
        if (Math.abs(dx) < 50 || Math.abs(dx) < Math.abs(dy) * 1.5) return;
        const rtl = getComputedStyle(this).direction === 'rtl';
        this.show(this.index + (dx < 0 ? 1 : -1) * (rtl ? -1 : 1));
      });
      on(this, 'pointercancel', () => { this.gesture = null; });
      on(this, 'dragstart', event => { if (event.target.tagName === 'IMG') event.preventDefault(); });
      on(document, 'visibilitychange', () => this.schedule());
      on(this.motion, 'change', () => { if (this.motion.matches) this.paused = true; this.schedule(); });
      on(document, 'shopify:block:select', event => {
        const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
        if (index < 0 || !this.contains(event.target)) return;
        this.editing = true;
        this.paused = true;
        this.show(index, false);
      });
      on(document, 'shopify:block:deselect', event => { if (this.contains(event.target)) { this.editing = false; this.schedule(); } });
      this.schedule();
    }
    disconnectedCallback() {
      this.abort?.abort();
      clearTimeout(this.timer);
    }
    hydrate(slide) {
      slide.querySelectorAll('[data-srcset]').forEach(image => { image.setAttribute('srcset', image.dataset.srcset); image.removeAttribute('data-srcset'); });
      slide.querySelectorAll('[data-src]').forEach(image => { image.setAttribute('src', image.dataset.src); image.removeAttribute('data-src'); });
    }
    show(index, manual = true) {
      index = (index + this.slides.length) % this.slides.length;
      if (manual) this.paused = true;
      if (index === this.index) { this.schedule(); return; }
      this.hydrate(this.slides[index]);
      if (this.slides[this.index].contains(document.activeElement)) this.querySelector('[data-hero-next]').focus();
      this.slides.forEach((slide, position) => {
        const active = position === index;
        slide.inert = !active;
        slide.setAttribute('aria-hidden', String(!active));
        const dot = this.dots[position];
        dot.tabIndex = active ? 0 : -1;
        if (active) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
      this.index = index;
      this.dataset.activeSlide = String(index + 1);
      if (manual) {
        const format = new Intl.NumberFormat(document.documentElement.lang);
        this.status.textContent = this.dataset.statusTemplate.replace('[current]', format.format(index + 1)).replace('[total]', format.format(this.slides.length));
      }
      this.schedule();
    }
    schedule() {
      clearTimeout(this.timer);
      const reduced = this.motion.matches;
      const playing = this.autoplay && !this.paused && !this.hovered && !this.editing && !reduced && !document.hidden;
      this.dataset.playing = String(playing);
      this.status.setAttribute('aria-live', playing ? 'off' : 'polite');
      if (this.play) {
        this.play.disabled = reduced;
        this.play.dataset.paused = String(this.paused || reduced);
        this.play.setAttribute('aria-label', reduced ? this.play.dataset.reducedLabel : this.paused ? this.play.dataset.playLabel : this.play.dataset.pauseLabel);
      }
      if (playing) this.timer = setTimeout(() => { this.show(this.index + 1, false); }, Math.max(5000, Number(this.dataset.interval) || 5000));
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["routine-bundles"] && !Shopify.designMode) return;
  try {
    
function initPrimeRoutines(scope = document) {
  scope.querySelectorAll('[data-routine-section]').forEach(section => {
    const filters = section.querySelector('[data-routine-filters]');
    if (!filters || filters.dataset.ready) return;
    filters.dataset.ready = 'true';
    filters.hidden = false;
    filters.addEventListener('click', event => {
      const button = event.target.closest('[data-routine-filter]');
      if (!button) return;
      filters.querySelectorAll('button').forEach(control => control.setAttribute('aria-pressed', String(control === button)));
      let count = 0;
      section.querySelectorAll('[data-routine-category]').forEach(card => {
        card.hidden = button.dataset.routineFilter !== 'all' && card.dataset.routineCategory !== button.dataset.routineFilter;
        if (!card.hidden) count++;
      });
      section.querySelector('[data-routine-empty]').hidden = count > 0;
      const status = section.querySelector('[data-routine-status]');
      status.textContent = status.dataset.countText.replace('[count]', String(count));
    });
  });
}
initPrimeRoutines();
document.addEventListener('shopify:section:load', event => initPrimeRoutines(event.target));

  } catch(e) { console.error(e); }
})();
})();
